(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collapsible-content"] && !Shopify.designMode) return;
  try {
    
  class CollapsibleContent {
    constructor(sectionId) {
      this.sectionId = sectionId;
      this.container = document.querySelector(`[data-section-id="${sectionId}"]`);
      if (!this.container) return;
      this.initAccordion();
    }

    initAccordion() {
      const triggers = this.container.querySelectorAll('.collapsible-item__trigger');
      triggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
          const expanded = trigger.getAttribute('aria-expanded') === 'true';
          const contentId = trigger.getAttribute('aria-controls');
          const content = document.getElementById(contentId);
          trigger.setAttribute('aria-expanded', !expanded);
          if (content) {
            if (expanded) {
              content.setAttribute('hidden', '');
            } else {
              content.removeAttribute('hidden');
            }
          }
        });
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-section-type="collapsible-content"]').forEach(el => {
      new CollapsibleContent(el.dataset.sectionId);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hoodies-footer-menus')) {
  customElements.define('hoodies-footer-menus', class extends HTMLElement {
    connectedCallback() {
      this.media = window.matchMedia('(max-width: 749px)');
      this.groups = Array.from(this.querySelectorAll('.hoodies-footer__group'));
      this.sync = () => {
        const collapse = this.media.matches && this.dataset.accordion === 'true';
        this.groups.forEach(group => {
          const summary = group.querySelector('summary');
          group.open = !collapse;
          group.toggleAttribute('data-static', !collapse);
          if (collapse) summary.removeAttribute('tabindex');
          else summary.setAttribute('tabindex', '-1');
        });
      };
      this.onClick = event => {
        const summary = event.target.closest('summary');
        if (summary && summary.parentElement.hasAttribute('data-static')) event.preventDefault();
      };
      this.onSelect = event => {
        const group = event.target.closest('.hoodies-footer__group');
        if (group && this.contains(group)) group.open = true;
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('shopify:block:select', this.onSelect);
      this.media.addEventListener('change', this.sync);
      this.sync();
      // Preserve access to an email field/error when Shopify returns the form.
      const error = this.querySelector('[role="alert"]');
      if (error) { error.setAttribute('tabindex', '-1'); error.focus(); }
    }
    disconnectedCallback() {
      this.media.removeEventListener('change', this.sync);
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('shopify:block:select', this.onSelect);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-activate-account"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.form-password-toggle').forEach(btn => {
      btn.addEventListener('click', () => {
        const input = document.getElementById(btn.dataset.target);
        if (!input) return;
        const isPassword = input.type === 'password';
        input.type = isPassword ? 'text' : 'password';
        btn.querySelector('.eye-open').style.display = isPassword ? 'none' : '';
        btn.querySelector('.eye-closed').style.display = isPassword ? '' : 'none';
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const addBtn = document.getElementById('AddAddressBtn');
    const addForm = document.getElementById('AddAddressForm');
    const cancelAddBtn = document.getElementById('CancelAddAddressBtn');

    if (addBtn && addForm) {
      addBtn.addEventListener('click', () => {
        const expanded = addBtn.getAttribute('aria-expanded') === 'true';
        addBtn.setAttribute('aria-expanded', !expanded);
        if (expanded) {
          addForm.setAttribute('hidden', '');
        } else {
          addForm.removeAttribute('hidden');
          addForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    if (cancelAddBtn && addForm && addBtn) {
      cancelAddBtn.addEventListener('click', () => {
        addForm.setAttribute('hidden', '');
        addBtn.setAttribute('aria-expanded', 'false');
      });
    }

    // Edit buttons
    document.querySelectorAll('.address-card__action-btn--edit').forEach(btn => {
      btn.addEventListener('click', () => {
        const addressId = btn.dataset.addressId;
        const editForm = document.getElementById(`EditAddressForm-${addressId}`);
        if (!editForm) return;
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', !expanded);
        if (expanded) {
          editForm.setAttribute('hidden', '');
        } else {
          editForm.removeAttribute('hidden');
          editForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    // Cancel edit buttons
    document.querySelectorAll('.address-edit-cancel-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const addressId = btn.dataset.addressId;
        const editForm = document.getElementById(`EditAddressForm-${addressId}`);
        const editBtn = document.querySelector(`[data-address-id="${addressId}"].address-card__action-btn--edit`);
        if (editForm) editForm.setAttribute('hidden', '');
        if (editBtn) editBtn.setAttribute('aria-expanded', 'false');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const copyBtns = document.querySelectorAll('.share-btn--copy');
    copyBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const url = btn.dataset.copyUrl;
        navigator.clipboard.writeText(url).then(() => {
          const original = btn.innerHTML;
          btn.textContent = 'Copied!';
          setTimeout(() => { btn.innerHTML = original; }, 2000);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const layoutBtns = document.querySelectorAll('.blog-layout-btn');
    const articleContainer = document.querySelector('[id^="BlogArticles-"]');
    if (!articleContainer) return;

    layoutBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const layout = btn.dataset.layout;
        layoutBtns.forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        articleContainer.classList.remove('blog-articles--grid', 'blog-articles--list');
        articleContainer.classList.add(`blog-articles--${layout}`);
        document.querySelectorAll('.article-card').forEach(card => {
          card.classList.remove('article-card--grid', 'article-card--list');
          card.classList.add(`article-card--${layout}`);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  class CollectionSection {
    constructor(sectionId) {
      this.sectionId = sectionId;
      this.container = document.querySelector(`[data-section-id="${sectionId}"]`);
      if (!this.container) return;

      this.filtersForm = document.getElementById(`CollectionFiltersForm-${sectionId}`);
      this.filtersPanel = document.getElementById(`CollectionFilters-${sectionId}`);
      this.filterMobileBtn = document.getElementById(`FilterMobileBtn-${sectionId}`);
      this.filtersCloseMobile = document.getElementById(`FiltersCloseMobile-${sectionId}`);
      this.filterDrawerBackdrop = document.getElementById(`FilterDrawerBackdrop-${sectionId}`);
      this.sortSelect = document.getElementById(`SortBy-${sectionId}`);
      this.productGrid = document.getElementById(`ProductGrid-${sectionId}`);
      this.loadingOverlay = document.getElementById(`CollectionLoading-${sectionId}`);
      this.clearFiltersBtn = document.getElementById(`ClearFiltersBtn-${sectionId}`);

      this.initFilterGroups();
      this.initFilterSubmit();
      this.initSortBy();
      this.initGridListToggle();
      this.initMobileFilters();
      this.initInfiniteScroll();
    }

    initFilterGroups() {
      const toggleBtns = this.container.querySelectorAll('.filter-group__toggle');
      toggleBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          const expanded = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', !expanded);
          const contentId = btn.getAttribute('aria-controls');
          const content = document.getElementById(contentId);
          if (content) {
            content.style.display = expanded ? 'none' : '';
          }
        });
      });
    }

    initFilterSubmit() {
      if (!this.filtersForm) return;
      const checkboxes = this.filtersForm.querySelectorAll('[data-filter-submit]');
      checkboxes.forEach(input => {
        input.addEventListener('change', () => this.submitFilters());
      });

      if (this.clearFiltersBtn) {
        this.clearFiltersBtn.addEventListener('click', () => {
          const url = window.location.pathname;
          window.location.href = url;
        });
      }

      let priceTimer;
      const priceInputs = this.filtersForm.querySelectorAll('[data-filter-submit-delayed]');
      priceInputs.forEach(input => {
        input.addEventListener('input', () => {
          clearTimeout(priceTimer);
          priceTimer = setTimeout(() => this.submitFilters(), 800);
        });
      });
    }

    submitFilters() {
      if (this.loadingOverlay) this.loadingOverlay.classList.add('is-loading');
      const data = new URLSearchParams(new FormData(this.filtersForm));
      if (this.sortSelect) data.set('sort_by', this.sortSelect.value);
      const url = `${window.location.pathname}?${data.toString()}`;
      window.location.href = url;
    }

    initSortBy() {
      if (!this.sortSelect) return;
      this.sortSelect.addEventListener('change', () => {
        if (this.loadingOverlay) this.loadingOverlay.classList.add('is-loading');
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.sortSelect.value);
        window.location.href = url.toString();
      });
    }

    initGridListToggle() {
      const toggleBtns = this.container.querySelectorAll('.grid-list-toggle__btn');
      toggleBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          const view = btn.dataset.view;
          toggleBtns.forEach(b => {
            b.classList.remove('is-active');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-pressed', 'true');
          if (this.productGrid) {
            if (view === 'list') {
              this.productGrid.classList.add('product-grid--view-list');
              this.productGrid.classList.remove('product-grid--view-grid');
            } else {
              this.productGrid.classList.add('product-grid--view-grid');
              this.productGrid.classList.remove('product-grid--view-list');
            }
          }
        });
      });
    }

    initMobileFilters() {
      if (!this.filtersPanel) return;

      const open = () => {
        this.filtersPanel.dataset.filtersOpen = 'true';
        if (this.filterMobileBtn) this.filterMobileBtn.setAttribute('aria-expanded', 'true');
        if (this.filterDrawerBackdrop) this.filterDrawerBackdrop.classList.add('is-visible');
        document.body.style.overflow = 'hidden';
      };

      const close = () => {
        this.filtersPanel.dataset.filtersOpen = 'false';
        if (this.filterMobileBtn) this.filterMobileBtn.setAttribute('aria-expanded', 'false');
        if (this.filterDrawerBackdrop) this.filterDrawerBackdrop.classList.remove('is-visible');
        document.body.style.overflow = '';
      };

      if (this.filterMobileBtn) this.filterMobileBtn.addEventListener('click', open);
      if (this.filtersCloseMobile) this.filtersCloseMobile.addEventListener('click', close);
      if (this.filterDrawerBackdrop) this.filterDrawerBackdrop.addEventListener('click', close);
    }

    initInfiniteScroll() {
      const trigger = document.getElementById(`InfiniteScrollTrigger-${this.sectionId}`);
      const spinner = document.getElementById(`InfiniteScrollSpinner-${this.sectionId}`);
      if (!trigger || !trigger.dataset.nextUrl) return;

      let loading = false;

      const observer = new IntersectionObserver(entries => {
        entries.forEach(async entry => {
          if (entry.isIntersecting && !loading && trigger.dataset.nextUrl) {
            loading = true;
            if (spinner) spinner.style.display = 'flex';
            try {
              const res = await fetch(trigger.dataset.nextUrl);
              const text = await res.text();
              const parser = new DOMParser();
              const doc = parser.parseFromString(text, 'text/html');
              const newGrid = doc.getElementById(`ProductGrid-${this.sectionId}`);
              const newTrigger = doc.getElementById(`InfiniteScrollTrigger-${this.sectionId}`);
              if (newGrid && this.productGrid) {
                Array.from(newGrid.children).forEach(child => {
                  this.productGrid.appendChild(child);
                });
                document.dispatchEvent(new CustomEvent('collection:updated', { detail: { source: 'infinite-scroll' } }));
              }
              if (newTrigger && newTrigger.dataset.nextUrl) {
                trigger.dataset.nextUrl = newTrigger.dataset.nextUrl;
              } else {
                delete trigger.dataset.nextUrl;
                observer.disconnect();
              }
            } catch (err) {
              console.error('Infinite scroll error:', err);
            } finally {
              loading = false;
              if (spinner) spinner.style.display = 'none';
            }
          }
        });
      });

      observer.observe(trigger);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-section-type="main-collection"]').forEach(el => {
      new CollectionSection(el.dataset.sectionId);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-faq"] && !Shopify.designMode) return;
  try {
    
  class FaqSection {
    constructor(sectionId) {
      this.sectionId = sectionId;
      this.container = document.querySelector(`[data-section-id="${sectionId}"]`);
      if (!this.container) return;

      this.faqList = document.getElementById(`FaqList-${sectionId}`);
      this.searchInput = document.getElementById(`FaqSearch-${sectionId}`);
      this.noResults = document.getElementById(`FaqNoResults-${sectionId}`);

      this.initAccordion();
      this.initCategoryTabs();
      this.initSearch();
    }

    initAccordion() {
      const triggers = this.container.querySelectorAll('.faq-item__trigger');
      triggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
          const expanded = trigger.getAttribute('aria-expanded') === 'true';
          const contentId = trigger.getAttribute('aria-controls');
          const content = document.getElementById(contentId);

          trigger.setAttribute('aria-expanded', !expanded);
          if (content) {
            if (expanded) {
              content.setAttribute('hidden', '');
            } else {
              content.removeAttribute('hidden');
            }
          }
        });
      });
    }

    initCategoryTabs() {
      const tabs = this.container.querySelectorAll('.faq-category-tab');
      const items = this.container.querySelectorAll('[data-faq-item]');
      if (!tabs.length) return;

      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          const category = tab.dataset.category;
          tabs.forEach(t => {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');

          items.forEach(item => {
            if (category === 'all' || item.dataset.category === category) {
              item.removeAttribute('hidden');
            } else {
              item.setAttribute('hidden', '');
            }
          });
        });
      });
    }

    initSearch() {
      if (!this.searchInput) return;
      const items = this.container.querySelectorAll('[data-faq-item]');
      let debounceTimer;

      this.searchInput.addEventListener('input', () => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          const query = this.searchInput.value.toLowerCase().trim();
          let visibleCount = 0;

          items.forEach(item => {
            const question = item.querySelector('.faq-item__question');
            const answer = item.querySelector('.faq-item__answer');
            const questionText = question ? question.textContent.toLowerCase() : '';
            const answerText = answer ? answer.textContent.toLowerCase() : '';
            const matches = !query || questionText.includes(query) || answerText.includes(query);

            if (matches) {
              item.classList.remove('faq-item--search-hidden');
              visibleCount++;
            } else {
              item.classList.add('faq-item--search-hidden');
            }
          });

          if (this.noResults) {
            if (visibleCount === 0 && query) {
              this.noResults.removeAttribute('hidden');
            } else {
              this.noResults.setAttribute('hidden', '');
            }
          }
        }, 300);
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-section-type="main-faq"]').forEach(el => {
      new FaqSection(el.dataset.sectionId);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const forgotBtn = document.getElementById('ForgotPasswordBtn');
    const backBtn = document.getElementById('BackToLoginBtn');
    const loginForm = document.getElementById('LoginForm');
    const recoverForm = document.getElementById('RecoverPasswordForm');

    if (forgotBtn && loginForm && recoverForm) {
      forgotBtn.addEventListener('click', () => {
        loginForm.style.display = 'none';
        recoverForm.style.display = 'block';
      });
    }

    if (backBtn && loginForm && recoverForm) {
      backBtn.addEventListener('click', () => {
        recoverForm.style.display = 'none';
        loginForm.style.display = 'block';
      });
    }

    // Auto-show recover form if hash is present
    if (window.location.hash === '#recover') {
      if (loginForm && recoverForm) {
        loginForm.style.display = 'none';
        recoverForm.style.display = 'block';
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  class ProductPage {
    constructor(section) {
      this.section = section;
      this.sectionId = section.id;
      this.container = document.querySelector(`[data-section-id="${this.sectionId}"]`);
      if (!this.container) return;

      this.mainGallery = this.container.querySelector(`#ProductGalleryMain-${this.sectionId}`);
      this.thumbsContainer = this.container.querySelector(`#ProductGalleryThumbs-${this.sectionId}`);
      this.stickyAtc = document.querySelector(`#StickyAtc-${this.sectionId}`);
      this.atcBtn = this.container.querySelector(`#ProductFormSubmit-${this.sectionId}`);
      this.zoomModal = document.querySelector(`#ZoomModal-${this.sectionId}`);
      this.zoomImage = document.querySelector(`#ZoomModalImage-${this.sectionId}`);

      this.initThumbnails();
      this.initStickyAtc();
      this.initZoom();
      this.initQuantitySelector();
      this.initCollapsibleTabs();
      this.initShareCopy();
    }

    initThumbnails() {
      if (!this.thumbsContainer) return;
      const thumbs = this.thumbsContainer.querySelectorAll('.product-gallery__thumb');
      thumbs.forEach(thumb => {
        thumb.addEventListener('click', () => {
          const mediaId = thumb.dataset.targetMediaId;
          this.showMedia(mediaId);
          thumbs.forEach(t => t.classList.remove('is-active'));
          thumb.classList.add('is-active');
        });
      });
    }

    showMedia(mediaId) {
      if (!this.mainGallery) return;
      const slides = this.mainGallery.querySelectorAll('.product-gallery__slide');
      slides.forEach(slide => {
        if (slide.dataset.mediaId === mediaId) {
          slide.classList.add('is-active');
        } else {
          slide.classList.remove('is-active');
        }
      });
    }

    initStickyAtc() {
      if (!this.stickyAtc || !this.atcBtn) return;
      const observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.stickyAtc.classList.remove('is-visible');
              this.stickyAtc.setAttribute('aria-hidden', 'true');
            } else {
              this.stickyAtc.classList.add('is-visible');
              this.stickyAtc.setAttribute('aria-hidden', 'false');
            }
          });
        },
        { rootMargin: '0px 0px -100px 0px' }
      );
      observer.observe(this.atcBtn);

      const stickyBtn = this.stickyAtc.querySelector('.sticky-atc__btn');
      if (stickyBtn) {
        stickyBtn.addEventListener('click', () => {
          const form = document.getElementById(stickyBtn.dataset.formId);
          if (form) {
            const submitBtn = form.querySelector('[type="submit"]');
            if (submitBtn) submitBtn.click();
          }
        });
      }
    }

    initZoom() {
      if (!this.zoomModal) return;
      const zoomBtns = this.container.querySelectorAll('.product-gallery__zoom-btn');
      zoomBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          const src = btn.dataset.zoomSrc;
          if (this.zoomImage) this.zoomImage.src = src;
          this.zoomModal.removeAttribute('hidden');
          document.body.style.overflow = 'hidden';
        });
      });

      const closeBtn = this.zoomModal.querySelector('.zoom-modal__close');
      const backdrop = this.zoomModal.querySelector('.zoom-modal__backdrop');

      const closeModal = () => {
        this.zoomModal.setAttribute('hidden', '');
        document.body.style.overflow = '';
      };

      if (closeBtn) closeBtn.addEventListener('click', closeModal);
      if (backdrop) backdrop.addEventListener('click', closeModal);

      document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && !this.zoomModal.hasAttribute('hidden')) closeModal();
      });
    }

    initQuantitySelector() {
      const selectors = this.container.querySelectorAll('.quantity-selector');
      selectors.forEach(selector => {
        const input = selector.querySelector('.quantity-selector__input');
        const minusBtn = selector.querySelector('[data-action="decrement"]');
        const plusBtn = selector.querySelector('[data-action="increment"]');
        if (!input) return;

        if (minusBtn) {
          minusBtn.addEventListener('click', () => {
            const val = parseInt(input.value, 10);
            if (val > 1) input.value = val - 1;
          });
        }
        if (plusBtn) {
          plusBtn.addEventListener('click', () => {
            const max = parseInt(input.max, 10) || 999;
            const val = parseInt(input.value, 10);
            if (val < max) input.value = val + 1;
          });
        }
      });
    }

    initCollapsibleTabs() {
      const triggers = this.container.querySelectorAll('.collapsible-tab__trigger');
      triggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
          const expanded = trigger.getAttribute('aria-expanded') === 'true';
          const contentId = trigger.getAttribute('aria-controls');
          const content = document.getElementById(contentId);
          trigger.setAttribute('aria-expanded', !expanded);
          if (content) {
            if (expanded) {
              content.setAttribute('hidden', '');
            } else {
              content.removeAttribute('hidden');
            }
          }
        });
      });
    }

    initShareCopy() {
      const copyBtns = this.container.querySelectorAll('.share-btn--copy');
      copyBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          const url = btn.dataset.copyUrl;
          navigator.clipboard.writeText(url).then(() => {
            btn.setAttribute('aria-label', 'Link copied!');
            setTimeout(() => btn.setAttribute('aria-label', 'Copy link'), 2000);
          });
        });
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-section-type="main-product"]').forEach(el => {
      new ProductPage({ id: el.dataset.sectionId });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const toggleBtns = document.querySelectorAll('.form-password-toggle');
    toggleBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const targetId = btn.dataset.target;
        const input = document.getElementById(targetId);
        if (!input) return;
        const isPassword = input.type === 'password';
        input.type = isPassword ? 'text' : 'password';
        const eyeOpen = btn.querySelector('.eye-open');
        const eyeClosed = btn.querySelector('.eye-closed');
        if (eyeOpen) eyeOpen.style.display = isPassword ? 'none' : '';
        if (eyeClosed) eyeClosed.style.display = isPassword ? '' : 'none';
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-reset-password"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // Password toggle
    document.querySelectorAll('.form-password-toggle').forEach(btn => {
      btn.addEventListener('click', () => {
        const input = document.getElementById(btn.dataset.target);
        if (!input) return;
        const isPass = input.type === 'password';
        input.type = isPass ? 'text' : 'password';
        btn.querySelector('.eye-open').style.display = isPass ? 'none' : '';
        btn.querySelector('.eye-closed').style.display = isPass ? '' : 'none';
      });
    });

    // Password match validation
    const passwordInput = document.getElementById('ResetPassword');
    const confirmInput = document.getElementById('ResetPasswordConfirm');
    const matchHint = document.getElementById('PasswordMatchHint');
    const submitBtn = document.getElementById('ResetPasswordSubmit');

    const validateMatch = () => {
      if (!confirmInput.value) {
        matchHint.textContent = '';
        matchHint.className = 'form-hint';
        return;
      }
      if (passwordInput.value === confirmInput.value) {
        matchHint.textContent = 'Passwords match.';
        matchHint.className = 'form-hint form-hint--success';
        if (submitBtn) submitBtn.disabled = false;
      } else {
        matchHint.textContent = 'Passwords do not match.';
        matchHint.className = 'form-hint form-hint--error';
        if (submitBtn) submitBtn.disabled = true;
      }
    };

    if (passwordInput && confirmInput && matchHint) {
      passwordInput.addEventListener('input', validateMatch);
      confirmInput.addEventListener('input', validateMatch);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const tabs = document.querySelectorAll('.search-tab');
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const targetId = tab.getAttribute('aria-controls');
        tabs.forEach(t => {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        document.querySelectorAll('.search-tab-content').forEach(panel => {
          panel.classList.remove('is-active');
          panel.setAttribute('hidden', '');
        });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        const target = document.getElementById(targetId);
        if (target) {
          target.classList.add('is-active');
          target.removeAttribute('hidden');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mega-menu"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeSportsMenu = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const mobileToggle = root.querySelector('.sports-mega-menu__mobile-toggle');
      const navigation = root.querySelector('.sports-mega-menu__navigation');
      const triggers = [...root.querySelectorAll('[data-menu-trigger]')];
      const track = root.querySelector('[data-team-track]');
      const previous = root.querySelector('[data-team-previous]');
      const next = root.querySelector('[data-team-next]');
      const desktopQuery = window.matchMedia('(min-width: 990px)');

      const closePanels = (except = null) => {
        triggers.forEach((trigger) => {
          if (trigger === except) return;
          const panel = document.getElementById(trigger.getAttribute('aria-controls'));
          trigger.setAttribute('aria-expanded', 'false');
          if (panel) panel.hidden = true;
        });
      };

      const setPanel = (trigger, open) => {
        const panel = document.getElementById(trigger.getAttribute('aria-controls'));
        if (!panel) return;
        if (open) closePanels(trigger);
        trigger.setAttribute('aria-expanded', String(open));
        panel.hidden = !open;
      };

      mobileToggle?.addEventListener('click', () => {
        const open = mobileToggle.getAttribute('aria-expanded') !== 'true';
        mobileToggle.setAttribute('aria-expanded', String(open));
        navigation?.classList.toggle('is-open', open);
        if (!open) closePanels();
      });

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          setPanel(trigger, trigger.getAttribute('aria-expanded') !== 'true');
        });

        trigger.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowDown') {
            event.preventDefault();
            setPanel(trigger, true);
            document.getElementById(trigger.getAttribute('aria-controls'))?.querySelector('a')?.focus();
          }
        });

        trigger.closest('.sports-mega-menu__nav-item, .sports-mega-menu__team-item')?.addEventListener('mouseenter', () => {
          if (desktopQuery.matches) setPanel(trigger, true);
        });
      });

      root.querySelector('.sports-mega-menu__nav-shell')?.addEventListener('mouseleave', () => {
        if (desktopQuery.matches) closePanels();
      });

      root.querySelector('.sports-mega-menu__teams-shell')?.addEventListener('mouseleave', () => {
        if (desktopQuery.matches) closePanels();
      });

      root.querySelectorAll('[data-menu-file-icon]').forEach((image) => {
        image.addEventListener('error', () => image.parentElement?.classList.add('is-missing'));
      });

      document.addEventListener('click', (event) => {
        if (!root.contains(event.target)) closePanels();
      });

      root.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closePanels();
          mobileToggle?.focus();
        }
      });

      const updateArrows = () => {
        if (!track) return;
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        if (previous) previous.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= maxScroll - 2 || maxScroll === 0;
      };

      const scrollTeams = (direction) => {
        if (!track) return;
        const distance = Math.max(220, track.clientWidth * 0.75);
        track.scrollBy({ left: distance * direction, behavior: 'smooth' });
      };

      previous?.addEventListener('click', () => scrollTeams(-1));
      next?.addEventListener('click', () => scrollTeams(1));
      track?.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows, { passive: true });
      desktopQuery.addEventListener('change', () => {
        closePanels();
        mobileToggle?.setAttribute('aria-expanded', 'false');
        navigation?.classList.remove('is-open');
      });
      updateArrows();
    };

    document.querySelectorAll('[data-sports-mega-menu]').forEach(initializeSportsMenu);

    document.addEventListener('shopify:section:load', (event) => {
      initializeSportsMenu(event.target.querySelector('[data-sports-mega-menu]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('hoodies-recommendations')) {
  customElements.define('hoodies-recommendations', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      this.addEventListener('click', event => { if (event.target.closest('[data-retry]')) this.load(); }, {signal:this.events.signal});
      if (this.dataset.productId && this.dataset.performed !== 'true' && !this.loaded) this.load();
    }
    async load() {
      if (this.loading || !this.dataset.productId) return;
      this.loading = true;
      this.request = new AbortController();
      const request = this.request;
      this.setAttribute('aria-busy','true');
      const status = this.querySelector('[data-status]');
      const retry = this.querySelector('[data-retry]');
      retry.hidden = true; status.textContent = '';
      const timeout = setTimeout(() => request.abort(), 12000);
      try {
        const url = new URL(this.dataset.url, window.location.origin);
        const response = await fetch(url.href, {credentials:'same-origin',signal:request.signal});
        if (!response.ok) throw new Error('Recommendation request failed');
        const html = await response.text();
        if (!this.isConnected || request.signal.aborted) return;
        const doc = new DOMParser().parseFromString(html,'text/html');
        const replacement = Array.from(doc.querySelectorAll('hoodies-recommendations')).find(item => item.dataset.sectionId === this.dataset.sectionId);
        if (!replacement || replacement.dataset.performed !== 'true') throw new Error('Invalid recommendation response');
        const results = replacement.querySelector('[data-results]');
        if (results && results.querySelector('[data-product-card]')) this.querySelector('[data-results]').replaceWith(results);
        this.loaded = true;
        this.dispatchEvent(new CustomEvent('product-recommendations:loaded',{bubbles:true}));
      } catch (_) {
        if (!this.isConnected) return;
        const hasFallback = Boolean(this.querySelector('[data-product-card]'));
        if (this.dataset.editor === 'true' || !hasFallback) {
          status.textContent = hasFallback ? 'Showing fallback products. Automatic recommendations could not load.' : 'Recommendations could not load. Please try again.';
          retry.hidden = false;
        }
      } finally {
        clearTimeout(timeout);
        if (this.request === request) { this.loading = false; this.removeAttribute('aria-busy'); }
      }
    }
    disconnectedCallback() {
      this.events?.abort(); this.events = null;
      this.request?.abort(); this.loading = false;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
  class RecentlyViewed {
    constructor(container) {
      this.container = container;
      this.sectionId = container.dataset.sectionId;
      this.currentProductId = container.dataset.currentProductId;
      this.productsToShow = parseInt(container.dataset.productsToShow, 10) || 4;
      this.grid = document.getElementById(`RecentlyViewedGrid-${this.sectionId}`);

      // Add current product to localStorage
      this.trackProduct();
      // Render the list
      this.render();
    }

    getStoredProducts() {
      try {
        return JSON.parse(localStorage.getItem('visionary-recently-viewed') || '[]');
      } catch {
        return [];
      }
    }

    trackProduct() {
      if (!this.currentProductId) return;
      const stored = this.getStoredProducts();
      const filtered = stored.filter(p => String(p.id) !== String(this.currentProductId));
      // We need to store product data for display — fetch from product JSON
      if (this.currentProductId) {
        fetch(`/products.json?ids=${this.currentProductId}`)
          .then(r => r.json())
          .catch(() => null);
      }
      // For handle-based approach, store the handle from current URL
      const pathParts = window.location.pathname.split('/');
      const handle = pathParts[pathParts.indexOf('products') + 1];
      if (handle) {
        const newEntry = { id: this.currentProductId, handle };
        filtered.unshift(newEntry);
        const toStore = filtered.slice(0, 20);
        try {
          localStorage.setItem('visionary-recently-viewed', JSON.stringify(toStore));
        } catch {}
      }
    }

    async render() {
      const stored = this.getStoredProducts();
      const filtered = stored.filter(p => String(p.id) !== String(this.currentProductId));
      if (filtered.length === 0) return;

      const toShow = filtered.slice(0, this.productsToShow);
      const handles = toShow.map(p => p.handle).filter(Boolean);
      if (handles.length === 0) return;

      try {
        const productData = await Promise.allSettled(
          handles.map(handle =>
            fetch(`/products/${handle}.js`).then(r => r.json())
          )
        );

        const products = productData
          .filter(r => r.status === 'fulfilled')
          .map(r => r.value);

        if (products.length === 0) return;

        this.container.style.display = '';

        this.grid.innerHTML = products.map(product => {
          const img = product.featured_image
            ? `<img
                src="${product.featured_image.replace(/(\.\w+)$/, '_400x$1')}"
                alt="${product.title}"
                class="recently-viewed-card__image"
                loading="lazy"
                width="400"
              >`
            : '';

          const priceFormatted = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: product.currency || 'USD'
          }).format((product.price || 0) / 100);

          return `
            <a href="/products/${product.handle}" class="recently-viewed-card">
              <div class="recently-viewed-card__image-wrapper">
                ${img}
              </div>
              <div class="recently-viewed-card__info">
                ${product.vendor ? `<p class="recently-viewed-card__vendor">${product.vendor}</p>` : ''}
                <p class="recently-viewed-card__title">${product.title}</p>
                <p class="recently-viewed-card__price">${priceFormatted}</p>
              </div>
            </a>
          `;
        }).join('');

      } catch (err) {
        console.error('Recently viewed error:', err);
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-section-type="recently-viewed"]').forEach(container => {
      new RecentlyViewed(container);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hoodies-video')) {
  const sdkPromises = {};
  function loadVideoSDK(provider) {
    const ready = () => provider === 'youtube' ? Boolean(window.YT?.Player) : Boolean(window.Vimeo?.Player);
    if (ready()) return Promise.resolve();
    if (!sdkPromises[provider]) sdkPromises[provider] = new Promise((resolve, reject) => {
      const src = provider === 'youtube' ? 'https://www.youtube.com/iframe_api' : 'https://player.vimeo.com/api/player.js';
      if (!Array.from(document.scripts).some(script => script.src === src)) {
        const script = document.createElement('script'); script.src = src; script.async = true; document.head.append(script);
      }
      let count = 0;
      const timer = setInterval(() => {
        if (ready()) { clearInterval(timer); resolve(); }
        else if (++count >= 150) { clearInterval(timer); reject(new Error('Video SDK unavailable')); }
      }, 100);
    }).catch(error => { delete sdkPromises[provider]; throw error; });
    return sdkPromises[provider];
  }
  const backgrounds = new Set();
  let globalStyle;
  function syncBackgrounds() {
    const owner = Array.from(backgrounds).find(item => item.isConnected);
    backgrounds.forEach(item => item.toggleAttribute('data-store-owner', item === owner));
    if (!globalStyle) {
      globalStyle = document.createElement('style');
      globalStyle.textContent = `
        body.hv-store-active #MainContent { position:relative; isolation:isolate; }
        body.hv-store-active #MainContent > .shopify-section { position:relative; z-index:1; }
        body.hv-store-active #MainContent > .hv-background-section { z-index:0; }
        body.hv-store-transparent #MainContent > .shopify-section,
        body.hv-store-transparent #MainContent > .shopify-section > section,
        body.hv-store-transparent .shopify-section-group-footer-group,
        body.hv-store-transparent .shopify-section-group-footer-group > section { background-color:transparent!important; }
      `;
      document.head.append(globalStyle);
    }
    document.body.classList.toggle('hv-store-active', Boolean(owner));
    document.body.classList.toggle('hv-store-transparent', Boolean(owner && owner.dataset.transparent === 'true'));
    backgrounds.forEach(item => item.closest('.shopify-section')?.classList.toggle('hv-background-section', item === owner));
  }
  customElements.define('hoodies-video', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.video = this.querySelector('video');
      this.template = this.querySelector('template.hv-embed');
      this.slot = this.querySelector('.hv-embed-slot');
      this.toggle = this.querySelector('[data-toggle]');
      this.mute = this.querySelector('[data-mute]');
      this.status = this.querySelector('.hv-status');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.manual = false;
      this.autoAttempted = false;
      this.starting = false;
      this.inView = false;
      this.querySelectorAll('[data-play]').forEach(button => button.hidden = false);
      const toolbar = this.querySelector('.hv-toolbar');
      if (toolbar) toolbar.hidden = false;
      this.addEventListener('click', event => {
        if (event.target.closest('[data-toggle], [data-play]')) {
          this.manual = true;
          if (this.video) {
            if (this.video.paused) this.play(false); else this.video.pause();
          } else if (this.frame) this.closeEmbed(); else this.openEmbed(false);
        }
        if (event.target.closest('[data-mute]') && this.video) this.video.muted = !this.video.muted;
      }, {signal});
      if (this.video) {
        this.video.defaultPlaybackRate = 0.5;
        this.video.playbackRate = 0.5;
        this.video.playsInline = true;
        if (this.dataset.autoplay === 'true') { this.video.defaultMuted = true; this.video.muted = true; }
        this.video.addEventListener('loadedmetadata', () => { this.video.playbackRate = 0.5; this.tryAutoplay(); }, {signal});
        this.video.addEventListener('canplay', () => this.tryAutoplay(), {signal});
        // Native controls remain available without JavaScript. JS supplies fallback
        // buttons when the merchant has disabled native controls.
        ['play','pause','ended','volumechange'].forEach(name => this.video.addEventListener(name, () => this.update(), {signal}));
        this.video.addEventListener('error', () => this.message('This video could not load. Please try again or check the video source.'), {signal});
      }
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          if (this.video) this.video.pause();
          if (this.frame) this.closeEmbed();
          this.autoAttempted = false;
        } else this.tryAutoplay();
      }, {signal});
      document.addEventListener('pointerdown', () => this.tryAutoplay(), {signal, passive:true});
      document.addEventListener('keydown', () => this.tryAutoplay(), {signal});
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) {
          if (this.video) this.video.pause();
          if (this.frame) this.closeEmbed();
        }
        this.updateParallax();
      }, {signal});
      if (this.dataset.mode === 'store-parallax') {
        backgrounds.add(this); syncBackgrounds();
        this.schedule = () => {
          if (!this.raf) this.raf = requestAnimationFrame(() => { this.raf = 0; this.updateParallax(); });
        };
        window.addEventListener('scroll', this.schedule, {passive:true, signal});
        window.addEventListener('resize', this.schedule, {signal});
        this.updateParallax();
      }
      const visible = value => {
        this.inView = value;
        this.tryAutoplay();
        if (!value && this.dataset.mode !== 'store-parallax') {
          if (this.video) this.video.pause();
          if (this.frame) this.closeEmbed();
        }
      };
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => visible(entries[0].isIntersecting), {threshold:0});
        this.observer.observe(this);
      } else visible(true);
      if (this.dataset.mode === 'store-parallax') this.tryAutoplay();
      this.update();
    }
    tryAutoplay() {
      if (this.dataset.autoplay !== 'true' || this.motion.matches || this.manual || document.hidden || this.starting) return;
      if (!this.inView && this.dataset.mode !== 'store-parallax') return;
      if (this.video) { if (this.video.paused) this.play(true); }
      else if (!this.frame) this.openEmbed(true);
    }
    message(text) { if (this.status) this.status.textContent = text; }
    async play(automatic) {
      if (!this.video) return;
      this.message('');
      this.starting = true;
      this.video.playbackRate = 0.5;
      if (automatic) this.video.muted = true;
      try { await this.video.play(); }
      catch (error) {
        if (!this.isConnected || error.name === 'AbortError') { this.starting = false; return; }
        this.message('Playback did not start. Tap Play video to try again.');
      }
      this.starting = false;
      this.update();
    }
    update() {
      const playing = this.video ? !this.video.paused && !this.video.ended : Boolean(this.frame);
      if (this.toggle) this.toggle.textContent = this.video ? (playing ? 'Pause video' : 'Play video') : (playing ? 'Close video' : 'Play video');
      if (this.mute) this.mute.textContent = this.video.muted ? 'Unmute' : 'Mute';
      this.querySelectorAll('[data-play]').forEach(button => button.hidden = playing);
    }
    openEmbed(automatic) {
      if (!this.template || this.frame) return;
      this.message('');
      const frame = this.template.content.firstElementChild.cloneNode(true);
      const url = new URL(frame.dataset.src);
      url.searchParams.set('autoplay', '1');
      url.searchParams.set(url.hostname.includes('youtube') ? 'mute' : 'muted', automatic ? '1' : '0');
      if (url.hostname.includes('youtube')) { url.searchParams.set('enablejsapi', '1'); url.searchParams.set('origin', window.location.origin); }
      frame.src = url.href;
      frame.removeAttribute('data-src');
      this.frame = frame;
      this.slot.replaceChildren(frame);
      this.configureEmbed(frame, automatic);
      this.classList.add('hv-external-active');
      this.updateParallax();
      this.update();
      // Native provider controls are always visible if autoplay is blocked.
      if (!automatic) frame.focus();
    }
    async configureEmbed(frame, automatic) {
      const youtube = frame.src.includes('youtube.com/');
      try {
        await loadVideoSDK(youtube ? 'youtube' : 'vimeo');
        if (this.frame !== frame || !this.isConnected) return;
        if (youtube) {
          this.player = new window.YT.Player(frame, {events: {
            onReady: event => {
              if (this.frame !== frame) return;
              const player = event.target;
              if (player.getAvailablePlaybackRates().includes(0.5)) player.setPlaybackRate(0.5);
              else this.message('This YouTube video does not support 0.5× speed. Upload the video to Shopify for slow playback.');
              if (automatic && !this.motion.matches && !document.hidden) { player.mute(); player.playVideo(); }
            }
          }});
        } else {
          const player = new window.Vimeo.Player(frame); this.player = player;
          await player.ready();
          if (this.frame !== frame) return;
          await player.setPlaybackRate(0.5).catch(() => this.message('This Vimeo video does not permit 0.5× speed. Upload the video to Shopify for slow playback.'));
          if (automatic && !this.motion.matches && !document.hidden) { await player.setVolume(0); await player.play().catch(() => {}); }
        }
      } catch (_) {
        if (this.frame === frame) this.message('Video controls are available in the player. Automatic speed adjustment could not load.');
      }
    }
    closeEmbed() {
      if (!this.frame) return;
      const focused = document.activeElement === this.frame;
      const player = this.player; this.player = null;
      if (player) { try { const cleanup = player.destroy(); if (cleanup?.catch) cleanup.catch(() => {}); } catch (_) {} }
      this.slot.replaceChildren(); this.frame = null;
      this.classList.remove('hv-external-active'); this.updateParallax(); this.update();
      if (focused) this.toggle?.focus();
    }
    updateParallax() {
      const inner = this.querySelector('.video-display__media-inner');
      if (!inner || this.dataset.mode !== 'store-parallax') return;
      if (this.motion.matches || this.frame) { inner.style.transform = ''; return; }
      const height = Math.max(window.innerHeight, 1);
      const distance = Math.max(document.documentElement.scrollHeight - height, 1);
      const progress = Math.max(0, Math.min(window.scrollY / distance, 1));
      const speed = Math.max(0, Math.min(Number(this.dataset.speed) || 0, 200));
      const scale = 1 + speed / height;
      inner.style.transform = `translate3d(0, ${(progress - .5) * speed}px, 0) scale(${scale})`;
    }
    disconnectedCallback() {
      this.abort?.abort(); this.abort = null;
      this.observer?.disconnect();
      if (this.raf) cancelAnimationFrame(this.raf); this.raf = 0;
      if (this.video) this.video.pause();
      this.closeEmbed();
      if (backgrounds.delete(this)) {
        this.closest('.shopify-section')?.classList.remove('hv-background-section');
        syncBackgrounds();
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
